import { type Option } from '@m/alchemy-ui/esm/form/types';
import { Select } from '@m/alchemy-ui/Select';
import { type IPageChallenge } from '../../../../../common/interfaces';
import { decodeHtml } from '../../../../../helpers';

interface IdeaSelectProps {
  challenges: IPageChallenge[];
  onValueChange: (challengeId: string) => void;
}

export const IdeaSelect = ({ challenges, onValueChange }: IdeaSelectProps) => (
  <Select
    data-testid="idea-select"
    defaultValue={challenges?.[0]?.id?.toString()}
    required
    isFullWidth
    options={
      challenges?.map((challenge) => ({
        key: challenge.id.toString(),
        label: decodeHtml(challenge.title),
        value: challenge.id.toString()
      })) as Option[]
    }
    onChange={(option) => onValueChange(option.value)}
  />
);
